"use client";

import { Button } from "@/app/components/ui/button";
import { Flex, Text } from "@radix-ui/themes";
import { signIn } from "next-auth/react";
import Image from "next/image";
import { Loader2 } from 'lucide-react';
import { useRouter } from "next/navigation";
import { cn } from "@/lib/utils";
import google from "@/public/google.png";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/app/components/ui/card";

interface GoogleSignInButtonProps {
  showSignIn: boolean;
  loggingIn: boolean;
  provider: null | "google" | "credentials";
  setLoggingIn: (loggingIn: boolean) => void;
  setProvider: (provider: null | "google" | "credentials") => void;
  callbackURL: string;
  loginPage?: boolean;
  onComplete?: () => void;
}

const GoogleSignInButton = ({
  showSignIn,
  loggingIn,
  provider,
  setLoggingIn,
  setProvider,
  callbackURL,
  loginPage = true,
  onComplete,
}: GoogleSignInButtonProps) => {
  const router = useRouter();

  if (!showSignIn) {
    return null;
  }

  return (
    <Card className="w-full mb-4">
      <CardHeader className="pb-4">
        <CardTitle className="text-center text-lg font-medium mb-1">Sign in with Google</CardTitle>
        <CardDescription className="text-sm text-gray-500">Please use this option if you originally signed up with your Google account.</CardDescription>
      </CardHeader>
      <CardContent className="pt-0">
        <Flex className="w-full" gap="3">
          <Button
            disabled={loggingIn}
            variant="outline"
            className="w-full h-12"
            onClick={() => {
              setLoggingIn(true);
              setProvider("google");
              signIn("google", { callbackUrl: callbackURL });
              router.refresh();
              if (onComplete) onComplete();
            }}
          >
            {loggingIn && provider === "google" ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <Image
                src={google}
                alt="Google"
                height="20"
                className="mr-2"
              />
            )}
            Google
          </Button>
        </Flex>
        {/* <Flex
          className={cn("w-full py-2", !loginPage && "my-4")}
          align="center"
        >
          <Flex className="w-full h-[1px] bg-slate-300 mr-3" />
          <Text className="text-slate-600 text-sm">OR</Text>
          <Flex className="w-full h-[1px] bg-slate-300 ml-3" />
        </Flex> */}
      </CardContent>
    </Card>
  );
};

export default GoogleSignInButton; 